export default "__VITE_ASSET__Byd4UcXD__"